import { render, staticRenderFns } from "./MyProcesses.vue?vue&type=template&id=7cb8fe31"
import script from "./MyProcesses.vue?vue&type=script&lang=js"
export * from "./MyProcesses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports